<template>
  <v-card class="ma-2">
    <v-card-title> 修改新聞 </v-card-title>
    <v-card-text>
      <v-divider />
      <item-form/>
    </v-card-text>
  </v-card>
</template>

<script>
import ItemForm from './Form.vue';

export default {
  components: {
    ItemForm,
  },
};
</script>
